"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChargeController = (function () {
    function ChargeController() {
    }
    ChargeController.calculateCharge = function (adFormat, period, kits, hasValue) {
        if (hasValue === false) {
            return undefined;
        }
        var currentKit = ChargeController.getMostCurrent(kits);
        var currentCharge = ChargeController.getExtraCharge(currentKit.extraCharges, adFormat, period);
        if (currentCharge) {
            switch (currentKit.chargeType.toUpperCase()) {
                case "PERCENT":
                    return { percent: currentCharge.value };
                case "FIXPRICE":
                    return { absolute: currentCharge.value };
                default:
                    throw new Error("Unknown charge type \"" + currentKit.chargeType + "\"");
            }
        }
        else {
            return undefined;
        }
    };
    ChargeController.getSubstituteCharge = function (period) {
        switch (period) {
            case "ME":
                return "DM";
            case "DR":
            case "DS":
                return "DD";
            default:
                return period;
        }
    };
    ChargeController.getExtraCharge = function (charges, adFormat, period) {
        var substitutePeriod = ChargeController.getSubstituteCharge(period);
        var result = _.find(charges, function (charge) {
            var chargePeriod = charge["period"];
            if (substitutePeriod && chargePeriod && substitutePeriod !== chargePeriod) {
                return false;
            }
            return (charge.adFormat === adFormat);
        });
        return result;
    };
    ChargeController.getMostCurrent = function (input) {
        return _.max(input, function (candidate) {
            return candidate["periodId"];
        });
    };
    return ChargeController;
}());
exports.ChargeController = ChargeController;
//# sourceMappingURL=chargeController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/chargeController.js
// module id = 46
// module chunks = 0